import React, {useEffect, useState} from 'react';

import styles from './ForgotPasswordStep2.module.scss';
import logo from '../../constants/images/logo.svg';
import ReturnToLoginPage from "../../components/UI/ReturnToLoginPage/ReturnToLoginPage";
import {Link, useLocation} from "react-router-dom";
import ErrorPage from "../ErrorPage/ErrorPage";
import {MAIN_ROUTES} from "../../routing/main_routes";
import {endPoints} from "../../configs/urls";
import {axiosService} from "../../services/axios.service";

const ForgotPasswordStep2 = () => {
  const {state} = useLocation();
  const [error, setError] = useState("");
  const [isTimerActive, setIsTimerActive] = useState(false);
  const [timer, setTimer] = useState(30);
  const [isEmailSent, setIsEmailSent] = useState(false);

  // timer for resend email(user can send only every 30 seconds)
  useEffect(() => {
    let interval;

    if (isTimerActive) {
      interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer === 1) {
            clearInterval(interval);
            setIsTimerActive(false);
          }
          return prevTimer - 1;
        });
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [isTimerActive]);

  if (!state) {
    return <ErrorPage/>;
  }

  const handleSendLink = async () => {
    try {
      await axiosService.post(endPoints.passwordRecovery.sendLink, {
        email: state?.email,
        password_recovery_url: process.env.REACT_APP_URL + MAIN_ROUTES.FORGOT_PASSWORD_STEP_3
      });

      setIsEmailSent(true);
      setIsTimerActive(true);
      setTimer(30); // Reset the timer
    } catch (e) {
      console.error(error);
      setError(JSON.stringify(error?.response?.data || error?.message));
    }
  }

  return (
    <div className={styles.forgotPasswordStep2_wrapper}>
      <div className={styles.forgotPasswordStep2_wrapper_forgotPasswordStep2}>
        <div className={styles.forgotPasswordStep2_wrapper_forgotPasswordStep2_title}>
          <img src={logo} alt="quality cleaning logo"/>

          <div>
            <h1 className={styles.title}>Перевірте свою пошту</h1>
            <p className={styles.paragraph}>Ми надіслали посилання для зміни пароля <span>{state?.email}</span></p>
          </div>
        </div>

        <div className={styles.forgotPasswordStep2_wrapper_forgotPasswordStep2_resendContainer}>
          <Link target="_blank" to={"https://www.google.com/intl/uk/gmail/about/"}>
            <button className={styles.forgotPasswordStep2_wrapper_forgotPasswordStep2_resendContainer_button}>Відкрити
              додаток пошти
            </button>
          </Link>

          <div className={styles.forgotPasswordStep2_wrapper_forgotPasswordStep2_resendContainer_resend}>
            <p className={`${styles.paragraphNotGet} ${styles.paragraphResend}`}>Не отримали листа?
            </p>
            <span
              className={styles.paragraphSend}
              style={{
                cursor: isTimerActive ? "auto" : "pointer",
                opacity: isTimerActive ? 0.5 : 1
              }}
              onClick={() => !isTimerActive && handleSendLink()}
            > Натисніть, щоб повторно надіслати {isTimerActive && `${timer}c`}</span>
          </div>

          <ReturnToLoginPage/>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordStep2;
